import Header from '../components/Header';
import Layout from '../components/Layout';

export default function EmailReservation() {
    return (
        <Layout>
            <Header />
            {/* TODO: add reservation inputs and payment inputs */}
        </Layout>
    );
}
